import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Subscription} from 'rxjs';
import {assignIn} from 'lodash';
import * as moment from 'moment';
import {AppConfigsService, AuthService} from '@ft/core';

@Component({
    selector: 'app-force-closure',
    templateUrl: './force-closure.component.html',
    styleUrls: ['./force-closure.component.scss']
})
export class ForceClosureDialogComponent implements OnInit {
    subscription: Subscription;

    model = {close_date: moment().format('YYYY-MM-DD'), reason: null};

    constructor(public dialogRef: MatDialogRef<ForceClosureDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any, public appConfigService: AppConfigsService, public authService: AuthService) {
    }

    ngOnInit(): void {
    }

    handleSave() {
        this.dialogRef.close(assignIn(this.model, !this.authService.isRoot() ? {force_by: this.authService.getStaff()} : {}));
    }
}
